<script setup>
</script>
<template>
    <div data-theme="light" class="min-h-screen bg-base-200">
      <div class="py-2">
        <div class="p-4 mt-20 flex justify-center">
          <NuxtLink to="/">
          <img
            src="assets/images/logo.png"
            alt="Annza Logo"
            width="150"
          >
          </NuxtLink>
        </div>
        <slot />
      </div>
  </div>
</template>

<style scoped></style>